import React from 'react';

import * as S from './Filters.styles';

import {ArrayTogglerBehaviorTypes} from '../../../../hooks/useArrayToggler';

import CheckBoxList from '../../../../../stories/components/hotels/common/CheckBoxList/CheckBoxList';

const AmenitiesFilter = ({updateFilter, amenitiesFiltersList, amenitiesFilter}) => {
  const onFilterSelect = (item, itemUnderAction, isSelected) => {
    updateFilter({amenities: item});
  };

  return (
    <CheckBoxList
      name="AMENITIES"
      data={amenitiesFiltersList}
      lookup={item => item}
      type={ArrayTogglerBehaviorTypes.multiSelect}
      renderItem={item => <S.TextTruncatorSpan>{item}</S.TextTruncatorSpan>}
      actionHandler={onFilterSelect}
      defaultState={amenitiesFilter || []}
      resetHandlerProp={() => {
        updateFilter({amenities: []});
      }}
      maxLength={3}
    />
  );
};

export default React.memo(AmenitiesFilter);
